import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ClipLoader } from "react-spinners";

const Settings = () => {
  return (
    <div className="p-[16px] md:px-[24px] ">
     
      <div className="w-full md:w-[50%] p-2 border rounded-lg  h-[50vh]">
        <Link to="/forgotpassword" className="flex items-center justify-between hover:bg-slate-100 mt-4 p-2 rounded-md border">
        <p>Change Password</p>
        <button
          type="submit"
          className=" py-[8px] text-center text-white bg-[#AF8544] px-4"
        >
          <p className="text-sm font-medium leading-[20px]">Update</p>
        </button>

        </Link>
      </div>
    </div>
  );
};

export default Settings;
